export default "__VITE_ASSET__CusTtIwajiF0cvbnEcE$sg__"